/**
 * @flow
 * @relayHash b9f2f678323fe3e4851f9a0d0fcbad97
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type ItemLots_itemLotEdges$ref = any;
export type ItemTransactionType = "ADD" | "DEDUCT" | "PURCHASE_RECEIPT" | "TRANSFER";
export type TransferItemInput = {|
  itemId: string,
  lotId: string,
  fromLotId: string,
  quantity: number,
  notes?: ?string,
|};
export type TransferItemMutationVariables = {|
  input: TransferItemInput
|};
export type TransferItemMutationResponse = {|
  +transferItem: {|
    +itemEdge: {|
      +node: {|
        +id: string,
        +logs: $ReadOnlyArray<{|
          +id: string,
          +user: {|
            +id: string
          |},
          +lot: {|
            +id: string
          |},
          +fromLot: ?{|
            +id: string
          |},
          +operation: ItemTransactionType,
          +quantity: number,
          +notes: ?string,
          +createdAt: any,
        |}>,
        +lots: {|
          +edges: ?$ReadOnlyArray<?{|
            +$fragmentRefs: ItemLots_itemLotEdges$ref
          |}>
        |},
      |}
    |}
  |}
|};
export type TransferItemMutation = {|
  variables: TransferItemMutationVariables,
  response: TransferItemMutationResponse,
|};
*/


/*
mutation TransferItemMutation(
  $input: TransferItemInput!
) {
  transferItem(input: $input) {
    itemEdge {
      node {
        id
        logs {
          id
          user {
            id
          }
          lot {
            id
          }
          fromLot {
            id
          }
          operation
          quantity
          notes
          createdAt
        }
        lots {
          edges {
            ...ItemLots_itemLotEdges
          }
        }
      }
    }
  }
}

fragment ItemLots_itemLotEdges on ItemLotEdge {
  quantity
  node {
    id
    lotNumber
    binNumber
    quantity
    expiresAt
  }
  ...ItemLotsTable_itemLotEdges
}

fragment ItemLotsTable_itemLotEdges on ItemLotEdge {
  quantity
  node {
    id
    lotNumber
    binNumber
    quantity
    expiresAt
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "TransferItemInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v3 = [
  (v2/*: any*/)
],
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "quantity",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "logs",
  "storageKey": null,
  "args": null,
  "concreteType": "ItemTransactionLog",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "user",
      "storageKey": null,
      "args": null,
      "concreteType": "User",
      "plural": false,
      "selections": (v3/*: any*/)
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "lot",
      "storageKey": null,
      "args": null,
      "concreteType": "Lot",
      "plural": false,
      "selections": (v3/*: any*/)
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "fromLot",
      "storageKey": null,
      "args": null,
      "concreteType": "Lot",
      "plural": false,
      "selections": (v3/*: any*/)
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "operation",
      "args": null,
      "storageKey": null
    },
    (v4/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "notes",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "createdAt",
      "args": null,
      "storageKey": null
    }
  ]
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "TransferItemMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "transferItem",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "TransferItemPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "itemEdge",
            "storageKey": null,
            "args": null,
            "concreteType": "ItemEdge",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Item",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v5/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "lots",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ItemLotConnection",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ItemLotEdge",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "FragmentSpread",
                            "name": "ItemLots_itemLotEdges",
                            "args": null
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "TransferItemMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "transferItem",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "TransferItemPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "itemEdge",
            "storageKey": null,
            "args": null,
            "concreteType": "ItemEdge",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Item",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v5/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "lots",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ItemLotConnection",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ItemLotEdge",
                        "plural": true,
                        "selections": [
                          (v4/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "node",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Lot",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "lotNumber",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "binNumber",
                                "args": null,
                                "storageKey": null
                              },
                              (v4/*: any*/),
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "expiresAt",
                                "args": null,
                                "storageKey": null
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "mutation",
    "name": "TransferItemMutation",
    "id": null,
    "text": "mutation TransferItemMutation(\n  $input: TransferItemInput!\n) {\n  transferItem(input: $input) {\n    itemEdge {\n      node {\n        id\n        logs {\n          id\n          user {\n            id\n          }\n          lot {\n            id\n          }\n          fromLot {\n            id\n          }\n          operation\n          quantity\n          notes\n          createdAt\n        }\n        lots {\n          edges {\n            ...ItemLots_itemLotEdges\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment ItemLots_itemLotEdges on ItemLotEdge {\n  quantity\n  node {\n    id\n    lotNumber\n    binNumber\n    quantity\n    expiresAt\n  }\n  ...ItemLotsTable_itemLotEdges\n}\n\nfragment ItemLotsTable_itemLotEdges on ItemLotEdge {\n  quantity\n  node {\n    id\n    lotNumber\n    binNumber\n    quantity\n    expiresAt\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'fcb11cfe44f23a0bd0ffc4386ad0b698';
module.exports = node;
